'use strict';

module.exports = navigator.clipboard || {
    readText: readText,
    writeText: writeText
};

function readText() {
    return Promise.reject();
}

function writeText(value) {
    var el = document.createElement('textarea');

    el.value = value;

    document.body.appendChild(el);
    el.select();

    var is = document.execCommand('copy');
    document.body.removeChild(el);

    if (is) return Promise.resolve();

    return Promise.reject();
}